<template>
    <div class="section text-center mt-1" v-if="loading_list">
        <div class="spinner-border text-primary" role="status"></div>
    </div>
    <div class="section pt-0 mt-0" v-if="!loading_list">
        <div class="listed-detail mt-1 page-title">
            <h3 class="text-center mt-1 mal-text custom-title">{{ isProfessionals ? 'Professionals In Member List' : 'Teachers In Member List' }}</h3>
        </div>
    </div>
    <div class="section mb-1" v-if="!loading_list">
        <div class="row mt-1">
            <div class="col-6">
                <div class="stat-box">
                    <div class="title">Total Count</div>
                    <div class="value text-primary">{{ totalTeachersCount }}
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="stat-box">
                    <div class="title">Registered Count</div>
                    <div class="value text-success">{{ registeredTeachersCount }}</div>
                </div>
            </div>
        </div>
    </div>
    <div class="section inset mt-1 mb-1" v-if="!loading_list">
        <div class="accordion" id="accordionExample2">
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#accordion001" aria-expanded="false">
                        <ion-icon name="filter-outline" role="img" class="md hydrated"
                            aria-label="wallet outline"></ion-icon>
                        Filter
                    </button>
                </h2>
                <div id="accordion001" class="accordion-collapse collapse"
                    data-bs-parent="#accordionExample2" style="">
                    <div class="accordion-body">
                        <div id="search" style="padding: 0px !important;">
                            <div class="form-group" v-if="currentUser && currentUser.user_level == 1">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_district">District</label>
                                    <select as="select" class="form-control custom-select" v-model="filter_district"
                                        name="filter_district" id="select4" @change="getZoneList($event.target.value)">
                                        <option value>---All---</option>
                                        <option v-for="district in district_list" v-bind:value="district.id"
                                            v-bind:key="district.id">{{
                                                district.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group"
                                v-if="!currentUser || !currentUser.user_level || currentUser.user_level <= 2">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_zone">Zone</label>
                                    <select as="select" class="form-control custom-select" v-model="filter_zone"
                                        name="filter_zone" id="select4" @change="getUnitList($event.target.value)">
                                        <option value>---All---</option>
                                        <option v-for="zone in zone_list" v-bind:value="zone.id" v-bind:key="zone.id">{{
                                            zone.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group"
                                v-if="!currentUser || !currentUser.user_level || currentUser.user_level <= 3">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_unit">Unit</label>
                                    <select as="select" class="form-control custom-select" v-model="filter_unit"
                                        name="filter_unit" id="select4">
                                        <option value>---All---</option>
                                        <option v-for="unit in unit_list" v-bind:value="unit.id" v-bind:key="unit.id">{{
                                            unit.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group"
                                v-if="!currentUser || !currentUser.user_level || currentUser.user_level <= 5">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_sex">Sex</label>
                                    <select as="select" class="form-control custom-select" v-model="filter_sex"
                                        name="filter_sex" id="select4">
                                        <option value>---All---</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group"
                                v-if="!currentUser || !currentUser.user_level || currentUser.user_level <= 5">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_member">Member OR Not</label>
                                    <select as="select" class="form-control custom-select" v-model="filter_member"
                                        name="filter_member" id="select4">
                                        <option value>---All---</option>
                                        <option value="member">Member</option>
                                        <option value="not_member">Not Member</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group"
                                v-if="!currentUser || !currentUser.user_level || currentUser.user_level <= 5">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_registered">Registered OR Not</label>
                                    <select as="select" class="form-control custom-select" v-model="filter_registered"
                                        name="filter_registered" id="select4">
                                        <option value>---All---</option>
                                        <option value="registered">Registered</option>
                                        <option value="not_register">Not Register</option>
                                    </select>
                                </div>
                            </div>
                                <div class="form-group"
                                    v-if="!currentUser || !currentUser.user_level || currentUser.user_level <= 5">
                                    <div class="input-wrapper">
                                        <label class="label" for="payment_status">Payment Status</label>
                                        <select as="select" class="form-control custom-select" v-model="payment_status"
                                            name="payment_status" id="select4">
                                            <option value>---All---</option>
                                            <option value="Paid">Paid</option>
                                            <option value="Not Paid">Not Paid</option>
                                        </select>
                                    </div>
                                </div>
                            <!-- <div class="form-group" v-if="responseData.permissions.user_level <= 4">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_status">Calling Status</label>
                                    <select as="select" class="form-control custom-select" v-model="filter_status"
                                        name="filter_status" id="select4">
                                        <option value>---All---</option>
                                        <option v-for="status in status_list" v-bind:value="status.id" v-bind:key="status.id">{{
                                            status.name }}
                                        </option>
                                    </select>
                                </div>
                            </div> -->
                            <div class="row">
                                <div class="col-6">
                                    <button type="button" class="btn btn-danger btn-sm me-1 mb-1" style="width: 100%;"
                                        @click="clearFilter()">
                                        <ion-icon name="trash-bin-outline" role="img" class="md hydrated"
                                            aria-label="add outline"></ion-icon>
                                        Clear
                                    </button>
                                </div>
                                <div class="col-6">
                                    <button type="button" class="btn btn-primary btn-sm me-1 mb-1" style="width: 100%;"
                                        @click="applyFilters()">
                                        <ion-icon name="search-outline" role="img" class="md hydrated"
                                            aria-label="add outline"></ion-icon>
                                        Filter
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="search" v-if="!loading_list && !$route.params.mobile">
        <form class="search-form">
            <div class="row">
                <div class="input-group form-group" style="width:70% !important;padding-right: 0px;">
                    <input type="number" placeholder="Search Mobile..." class="form-control" maxlength="99999999999"
                        focus v-model="search_qry" aria-describedby="basic-addon3"
                        style="border: 1px solid #1a418c; border-radius: 10px;" />
                </div>
                <div class="form-group" style="width:12% !important;">
                    <button type="button" class="btn btn-icon btn-outline-success me-1" @click="search()">
                        <ion-icon name="search-outline" role="img" class="md hydrated"
                            aria-label="newspaper outline"></ion-icon>
                    </button>
                </div>
                <div class="form-group" style="width:12% !important;">
                    <button type="button" class="btn btn-icon btn-outline-primary me-1" @click="displayAll">
                        <ion-icon name="list-outline" role="img" class="md hydrated"
                            aria-label="newspaper outline"></ion-icon>
                    </button>
                </div>
            </div>
        </form>
    </div>
    <div class="section text-center mt-1" v-if="search_loading">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    <div class="section pt-0 mt-0" v-if="searchResponse.message">
        <div class="listed-detail mt-1">
            <h4 class="text-center text-danger mt-1 mal-text">{{ searchResponse.message }}</h4>
        </div>
    </div>

    <!-- No Data Message -->
    <div class="section pt-0 mt-0"
        v-if="!loading_list && !activeLoading && (!activeData || !activeData.data || activeData.data.length === 0)">
        <span class="text-center d-block" style="margin: 2rem 0; font-size: 1.2rem; color: #6c757d;">No data
            found</span>
    </div>

    <!-- Teachers/Professionals List -->
    <ul class="listview image-listview inset text mb-2"
        v-if="!loading_list && !activeLoading && activeData && activeData.data && activeData.data.length > 0">
        <li v-for="(teacher, index) in activeData.data" v-bind:key="teacher.id || index"
            :style="{ 'background-color': background }">
            <a href="javascript:void(0)" class="item">
                <span class="sl-no">{{ (activeData.current_page - 1) * activeData.per_page + index +
                    1 }}</span>
                <div class="avatar-section">
                    <a href="javascript:void(0)">
                        <img src="assets/img/sample/avatar/avatar1.png" alt="avatar" class="image">
                        <span class="button-payment payment-verified" v-if="teacher.payment_status == 'Paid'">
                            <ion-icon name="card-outline"></ion-icon>
                        </span>
                        <span class="button" :class="teacher.registered === 'Registered' ? 'verified' : 'not-verified'">
                            <ion-icon :name="isProfessionals ? 'briefcase-outline' : 'school-outline'"></ion-icon>
                        </span>
                    </a>
                </div>
                <div class="in">
                    <div class="min-width-50">
                        <header :class="teacher.registered === 'Registered' ? 'text-success' : 'text-warning'">
                            {{ teacher.registered === 'Registered' ? 
                                (isProfessionals ? 'Registered Professional' : 'Registered Teacher') : 
                                (isProfessionals ? 'Unregistered Professional' : 'Unregistered Teacher') 
                            }}
                        </header>
                        <b class="text-primary">{{ teacher.name || 'Unknown Name' }}</b>
                        <footer class="text-secondary">
                            <ion-icon name="call-outline"></ion-icon>
                            {{ teacher.mobile || 'No mobile' }}
                        </footer>
                    </div>
                    <div class="card-button dropdown">
                        <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                            :data-bs-target="'#teacherActionSheet' + index" @click="showActionModel">
                            <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                        </button>
                    </div>

                    <!-- Teacher/Professional Action Sheet -->
                    <div class="modal fade action-sheet" :id="'teacherActionSheet' + index" tabindex="-1" role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">{{ isProfessionals ? 'Professional Actions' : 'Teacher Actions' }}</h5>
                                </div>
                                <div class="modal-body">
                                    <ul class="action-button-list">
                                        <li v-if="teacher.mobile">
                                            <a :href="'tel:' + teacher.mobile" class="btn btn-list text-primary">
                                                <span>
                                                    <ion-icon name="call-outline"></ion-icon> Call
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="teacher.mobile">
                                            <a :href="'https://wa.me/' + mobileToWhatsapp(teacher.mobile)"
                                                class="btn btn-list text-success">
                                                <span>
                                                    <ion-icon name="logo-whatsapp"></ion-icon> WhatsApp
                                                </span>
                                            </a>
                                        </li>
                                        <li class="action-divider"></li>
                                        <li>
                                            <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="close-outline"></ion-icon> Cancel
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        </li>
    </ul>

    <!-- Pagination Component -->
    <div class="section mt-2"
        v-if="!loading_list && !activeLoading && activeData && activeData.total > 0">
        <vue-awesome-paginate v-if="activeData.total > activeData.per_page"
            :total-items="activeData.total" :items-per-page="activeData.per_page"
            :max-pages-shown="3" v-model="activeData.current_page" :on-click="onPaginationClick"
            :show-ending-buttons="true" :show-breakpoint-buttons="false" />
    </div>

    <div class="section pt-0 mt-1 pb-2" v-if="searchResponse.contact && !search_loading">
        <div class="card">
            <div class="card-body">
                <Form @submit="handleRegistration" :validation-schema="schema">
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="id">ID</label>
                            <Field type="text" disabled class="form-control" name="id" v-model="formData.id"
                                placeholder="ID" autocomplete="off" />
                            <ErrorMessage name="id" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="id">വിസ്‌ഡം മെമ്പർ ആണോ?</label>
                            <Field type="text" disabled class="form-control" name="wisdom_member"
                                v-model="formData.wisdom_member" placeholder="" autocomplete="off" />
                            <ErrorMessage name="wisdom_member" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="name">പേര്</label>
                            <Field type="text" disabled class="form-control" name="name" v-model="formData.name"
                                placeholder="Name" autocomplete="off" />
                            <ErrorMessage name="name" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="mobile">മൊബൈൽ</label>
                            <Field type="number" disabled class="form-control" name="mobile" v-model="formData.mobile"
                                placeholder="0000000000" autocomplete="off" />
                            <ErrorMessage name="mobile" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="status">വിളിയുടെ status</label>
                            <Field as="select" disabled class="form-control custom-select" id="status" name="status"
                                v-model="formData.status">
                                <option value="" :disabled="true" selected>Select Status</option>
                                <option v-for="status in status_list" v-bind:key="status.id" v-bind:value="status.id">
                                    {{ status.name_mal }}
                                </option>
                            </Field>
                            <ErrorMessage name="status" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="mobile2">മൊബൈൽ 2</label>
                            <Field type="number" disabled class="form-control" name="mobile2" v-model="formData.mobile2"
                                placeholder="0000000000" autocomplete="off" />
                            <ErrorMessage name="mobile2" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label text-primary" for="sex">Sex</label>
                            <div class="form-check form-check-inline">
                                <input type="radio" disabled class="form-check-input" value="Male" name="Sex" id="sex_1"
                                    v-model="formData.sex" />
                                <label class="form-check-label" for="sex_1">Male &nbsp;</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" disabled class="form-check-input" value="Female" name="Sex"
                                    id="sex_2" v-model="formData.sex" />
                                <label class="form-check-label" for="sex_2">Female &nbsp;</label>
                            </div>
                            <ErrorMessage name="sex" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="district">ജില്ല</label>
                            <Field as="select" disabled class="form-control custom-select" id="district" name="district"
                                v-model="formData.district">
                                <option value="" :disabled="true" selected>Select District</option>
                                <option v-for="district in district_list" v-bind:key="district.id"
                                    v-bind:value="district.id">
                                    {{ district.name }}
                                </option>
                            </Field>
                            <ErrorMessage name="place" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="place">സ്ഥലം</label>
                            <Field type="text" disabled class="form-control" name="place" v-model="formData.place"
                                placeholder="Place" autocomplete="off" />
                            <ErrorMessage name="place" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="comments">അവർ പറഞ്ഞ അഭിപ്രായങ്ങൾ,
                                നിർദ്ദേശങ്ങൾ</label>
                            <Field type="text" disabled class="form-control" name="comments" v-model="formData.comments"
                                placeholder="---" autocomplete="off" />
                            <ErrorMessage name="comments" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic" v-for="(questian, index) in responseData.questians"
                        v-bind:key="questian.id">
                        <div class="input-wrapper" v-if="questian.question_type == 'DATE'">
                            <label class="label questians-label text-primary mal-text" :for="'field' + questian.id">
                                <b>{{ questian.question_text }}</b>
                            </label>
                            <Field type="date" disabled class="form-control" :name="'questian_air[' + index + ']'"
                                placeholder="..." v-model="questians_responses[index]"
                                :required="questian.question_validations == 'Y'" />
                            <i class="clear-input">
                                <ion-icon name="close-circle"></ion-icon>
                            </i>
                        </div>
                        <div class="input-wrapper"
                            v-if="questian.question_type == 'TX' || questian.question_type == 'TXT'">
                            <label class="label questians-label text-primary mal-text" :for="'field' + questian.id">
                                <b>{{ questian.question_text }}</b>
                            </label>
                            <Field type="text" disabled class="form-control" :name="'questian_air[' + index + ']'"
                                placeholder="..." v-model="questians_responses[index]"
                                :required="questian.question_validations == 'Y'" />
                            <i class="clear-input">
                                <ion-icon name="close-circle"></ion-icon>
                            </i>
                        </div>
                        <div class="input-wrapper" v-else-if="questian.question_type == 'SB'">
                            <label class="label questians-label text-primary mal-text" :for="'field' + questian.id">
                                <b>{{ questian.question_text }}</b>
                            </label>
                            <select as="select" disabled class="form-control custom-select"
                                v-model="questians_responses[index]" :required="questian.question_validations == 'Y'"
                                :name="'questian_air[' + index + ']'" id="select4">
                                <option value>---Select---</option>
                                <option v-for="option in convertToJson(questian.question_options)" v-bind:value="option"
                                    v-bind:key="option">{{ option }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label text-primary" for="visited_status">Visited Status</label>
                            <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" value="Visited" name="visited_status"
                                    id="visited_status_1" v-model="formData.visited_status" />
                                <label class="form-check-label" for="visited_status_1">Visited &nbsp;</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" value="Not Visited" name="visited_status"
                                    id="visited_status_2" v-model="formData.visited_status" />
                                <label class="form-check-label" for="visited_status_2">Not Visited &nbsp;</label>
                            </div>
                            <ErrorMessage name="visited_status" class="error-feedback" />
                        </div>
                    </div>
                    <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="btn_loading">
                        <span v-show="btn_loading" class="spinner-border spinner-border-sm"></span>
                        <span>Save</span>
                    </button>
                </Form>
            </div>
        </div>
    </div>
    <div class="section mt-2" v-if="!loading_list && responseData.all_contacts && responseData.all_contacts.total > 0">
        <vue-awesome-paginate v-if="responseData.all_contacts.total > 0" :total-items="responseData.all_contacts.total"
            :items-per-page="responseData.all_contacts.per_page" :max-pages-shown="3"
            v-model="responseData.all_contacts.current_page" :on-click="getCampign" :show-ending-buttons="true"
            :show-breakpoint-buttons="false" />
    </div>
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
</template>

<script>
import {
    Form,
    Field,
    ErrorMessage
} from "vee-validate";
import * as yup from "yup";
import UserService from "../../services/user.service";
import $ from "jquery";
import AlertModel from "../layouts/AlertModel.vue";
import DialogModel from "../layouts/DialogModel.vue";

export default {
    name: "Admin List",
    props: {
        unit_id: null,
        permissions: Object,
    },
    components: {
        Form,
        Field,
        ErrorMessage,
        AlertModel,
        DialogModel,
    },
    data() {
        const schema = yup.object().shape({
            name: yup.string().required("ഫിൽ ചെയ്യുക!"),
            mobile: yup.string().required("ഫിൽ ചെയ്യുക!"),
        });
        return {
            btn_loading: false,
            search_loading: false,
            loading: false,
            loading_list: false,
            schema,
            alert_type: "",
            alert_message: "",
            dialog_message: "",
            dialog_action: "",
            search_qry: '',
            directory_type_list: [],
            profession_list: [],
            skilset_list: [],
            adarsham_list: [],
            qualification_list: [],
            wisdom_programs_list: [],
            formData: {
                directory_type: [],
                wisdom_programs: [],
                profession: [],
                skilset: [],
                adarsham: [],
                qualification: [],
                name: '',
                mobile: '',
                mobile2: '',
                whatsapp: '',
                age: '',
                remarks: '',
                district: '',
                place: '',
                comments: '',
                status: '',
                wisdom_member: '',
                visited_status: ''
            },
            questians_responses: [],
            responseData: {
                campign: [],
                questians: [],
                all_contacts: {
                    data: [],
                    total: 0,
                    per_page: 20,
                    current_page: 1,
                    from: 0
                },
                permissions: {
                    user_level: 1
                }
            },
            searchResponse: {
                contact: '',
                message: ''
            },
            pending_contacts: [],
            all_contacts: [],
            status_list: [],
            zone_list: [],
            unit_list: [],
            district_list: [],
            filter_district: '',
            filter_zone: '',
            filter_unit: '',
            filter_sex: '',
            filter_registered: '',
            filter_member: '',
            teachersUnregistered: {
                data: [],
                total: 0,
                per_page: 20,
                current_page: 1,
                last_page: 1,
                from: 0,
                to: 0
            },
            teachersUnregisteredLoading: false,
            allTeachersUnfiltered: [],
            payment_status: '',
            registeredCount: 0,
            allRegisteredTeachers: [], // Store all registered teachers for accurate counting
            professionalsUnregistered: {
                data: [],
                total: 0,
                per_page: 20,
                current_page: 1,
                last_page: 1,
                from: 0,
                to: 0
            },
            professionalsUnregisteredLoading: false,
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        isProfessionals() {
            // Check if the route slug is 'proface' to determine if we're dealing with professionals
            return this.$route.params.slug === 'proface';
        },
        activeData() {
            // Return the active data source based on whether we're viewing professionals or teachers
            return this.isProfessionals ? this.professionalsUnregistered : this.teachersUnregistered;
        },
        activeLoading() {
            // Return the active loading state
            return this.isProfessionals ? this.professionalsUnregisteredLoading : this.teachersUnregisteredLoading;
        },
        childLength() {
            return parseInt(this.formData.lessthan_16_count);
        },
        hasActiveFilters() {
            return this.filter_district || this.filter_zone || this.filter_unit ||
                this.filter_sex || this.filter_member || this.filter_registered || this.payment_status;
        },
        filterCount() {
            let count = 0;
            if (this.filter_district) count++;
            if (this.filter_zone) count++;
            if (this.filter_unit) count++;
            if (this.filter_sex) count++;
            if (this.filter_member) count++;
            if (this.filter_registered) count++;
            if (this.payment_status) count++;
            return count;
        },
        totalTeachersCount() {
            // When payment_status filter is active, try to use the accurate computed count
            // Fallback to API total from activeData if we don't have all registered teachers loaded yet
            if (this.payment_status) {
                if (this.payment_status === 'Paid') {
                    // Use computed count if we have complete data
                    if (this.allRegisteredTeachers.length >= this.registeredCount && this.registeredCount > 0) {
                        return this.paidTeachersCount;
                    }
                    // Fallback: use the total from current filtered API response
                    // This should be the API's total for paid teachers across all pages
                    return this.activeData && this.activeData.total ? this.activeData.total : 0;
                } else if (this.payment_status === 'Not Paid') {
                    // Use computed count if we have complete data
                    if (this.allRegisteredTeachers.length >= this.registeredCount && this.registeredCount > 0) {
                        return this.notPaidTeachersCount;
                    }
                    // Fallback: use the total from current filtered API response
                    return this.activeData && this.activeData.total ? this.activeData.total : 0;
                }
            }
            
            // Otherwise, use the API total
            return this.activeData && this.activeData.total ? this.activeData.total : 0;
        },
        registeredTeachersCount() {
            // Use API-provided total for registered subset matching current filters/scope
            return this.registeredCount || 0;
        },
        unregisteredTeachersCount() {
            // Count of teachers who are not registered for the event
            return this.totalTeachersCount - this.registeredTeachersCount;
        },
        currentPageCount() {
            // Count of teachers/professionals on current page
            return this.activeData && this.activeData.data ? 
                   this.activeData.data.length : 0;
        },
        paidTeachersCount() {
            // Count of registered teachers with "Paid" status
            if (!this.allRegisteredTeachers || this.allRegisteredTeachers.length === 0) {
                return 0;
            }
            return this.allRegisteredTeachers.filter(teacher => {
                const paymentStatus = (teacher.payment_status || '').trim();
                return paymentStatus === 'Paid';
            }).length;
        },
        notPaidTeachersCount() {
            // Count of registered teachers with "Not Paid" status or null/empty status
            // This ensures paid + notPaid = registeredCount
            if (!this.allRegisteredTeachers || this.allRegisteredTeachers.length === 0) {
                return 0;
            }
            return this.allRegisteredTeachers.filter(teacher => {
                const paymentStatus = (teacher.payment_status || '').trim();
                // Count as "Not Paid" if status is "Not Paid" or null/empty/undefined
                return paymentStatus !== 'Paid';
            }).length;
        }
    },

    mounted() {
        if (!this.currentUser) {
            location.replace("/");
            return;
        }

        console.log('Component mounted, starting initialization...');
        this.$root.updateParent("രജിസ്റ്റർ ചെയ്യേണ്ട മെമ്പർമാർ");

        this.loading_list = true;

        this.getComboboxValues('CALL_CAMPAIGN_STATUS');
        this.getCampign();
        this.getDistrictList();
        this.getZoneList(this.responseData.permissions.district_id ? this.responseData.permissions.district_id : this.currentUser.district_id);

        if (this.currentUser.district_id) {
            this.getZoneList(this.currentUser.district_id);
        }

        // Call the appropriate API based on route slug
        if (this.isProfessionals) {
            this.getProfessionalsUnregistered();
        } else {
            this.getTeachersUnregistered();
        }

        // Fetch registered total matching current scope
        this.fetchRegisteredCount();

        setTimeout(() => {
            if (this.loading_list) {
                console.warn('Forcing loading_list to false due to timeout');
                this.loading_list = false;
                this.$forceUpdate();
            }
            if (this.teachersUnregisteredLoading) {
                console.warn('Forcing teachersUnregisteredLoading to false due to timeout');
                this.teachersUnregisteredLoading = false;
                this.$forceUpdate();
            }
        }, 3000);

        window.onpopstate = function () {
            if ($("body").hasClass("modal-open")) {
                location.reload();
            }
        };
    },

    methods: {
        getTeachersUnregistered(page = 1) {
            this.teachersUnregisteredLoading = true;

            let queryParams = new URLSearchParams();
            queryParams.append('event_id', '100');
            queryParams.append('page', page);

            if (this.currentUser && this.currentUser.user_level >= 2 && this.currentUser.district_id) {
                queryParams.append('district_id', this.currentUser.district_id);
            }
            if (this.currentUser && this.currentUser.user_level >= 3 && this.currentUser.zone_id) {
                queryParams.append('zone_id', this.currentUser.zone_id);
            }
            if (this.currentUser && this.currentUser.user_level >= 4 && this.currentUser.unit_id) {
                queryParams.append('unit_id', this.currentUser.unit_id);
            }

            const url = `teachers-unregistered?${queryParams.toString()}`;
            console.log('Loading teachers with URL:', url);

            return UserService.authGetRequest(url)
                .then((response) => {
                    console.log('Teachers API Response:', response);

                    if (response && response.data && response.data.status === 'success') {

                        if (response.data.data && typeof response.data.data === 'object' && response.data.data.data) {

                            this.teachersUnregistered = {
                                data: response.data.data.data || [],
                                total: response.data.data.total || 0,
                                per_page: response.data.data.per_page || 20,
                                current_page: response.data.data.current_page || 1,
                                last_page: response.data.data.last_page || 1,
                                from: response.data.data.from || 0,
                                to: response.data.data.to || 0
                            };
                        } else {
                            const allData = response.data.data || [];
                            const perPage = 20;
                            const totalItems = allData.length;
                            const totalPages = Math.ceil(totalItems / perPage);
                            const startIndex = (page - 1) * perPage;
                            const endIndex = startIndex + perPage;
                            const pageData = allData.slice(startIndex, endIndex);

                            this.teachersUnregistered = {
                                data: pageData,
                                total: totalItems,
                                per_page: perPage,
                                current_page: page,
                                last_page: totalPages,
                                from: startIndex + 1,
                                to: Math.min(endIndex, totalItems)
                            };

                            this.allTeachersUnfiltered = allData;
                        }
                    } else {
                        this.teachersUnregistered = {
                            data: [],
                            total: 0,
                            per_page: 20,
                            current_page: 1,
                            last_page: 1,
                            from: 0,
                            to: 0
                        };
                    }

                    console.log('Teachers loaded:', this.teachersUnregistered.data.length);
                    this.teachersUnregisteredLoading = false;

                    if (this.teachersUnregistered.data.length > 0) {
                        this.loading_list = false;
                        console.log('Main loading stopped - teachers data available');
                    }
                })
                .catch((error) => {
                    console.error('Error fetching teachers:', error);
                    this.teachersUnregistered = {
                        data: [],
                        total: 0,
                        per_page: 20,
                        current_page: 1,
                        last_page: 1,
                        from: 0,
                        to: 0
                    };
                    this.teachersUnregisteredLoading = false;
                });
        },

        // Fetch total of registered teachers for current scope/filters
        fetchRegisteredCount(page = 1) {
            let queryParams = new URLSearchParams();
            queryParams.append('event_id', '100');
            queryParams.append('page', page);

            // Apply scope: either explicit filters or user-level scoping
            if (this.filter_district) {
                queryParams.append('district_id', this.filter_district);
            } else if (this.currentUser && this.currentUser.user_level >= 2 && this.currentUser.district_id) {
                queryParams.append('district_id', this.currentUser.district_id);
            }

            if (this.filter_zone) {
                queryParams.append('zone_id', this.filter_zone);
            } else if (this.currentUser && this.currentUser.user_level >= 3 && this.currentUser.zone_id) {
                queryParams.append('zone_id', this.currentUser.zone_id);
            }

            if (this.filter_unit) {
                queryParams.append('unit_id', this.filter_unit);
            } else if (this.currentUser && this.currentUser.user_level >= 4 && this.currentUser.unit_id) {
                queryParams.append('unit_id', this.currentUser.unit_id);
            }

            if (this.filter_sex) {
                queryParams.append('gender', this.filter_sex);
            }
            // Don't include payment_status filter when fetching registered count
            // We need all registered teachers to calculate paid/not paid counts

            // Request only registered subset
            queryParams.append('registered', 'Y');

            // Use appropriate endpoint based on whether viewing professionals or teachers
            const endpoint = this.isProfessionals ? 'professionals-unregistered' : 'teachers-unregistered';
            const url = `${endpoint}?${queryParams.toString()}`;
            this.registeredCount = 0;

            return UserService.authGetRequest(url)
                .then((response) => {
                    if (response && response.data && response.data.status === 'success') {
                        if (response.data.data && typeof response.data.data === 'object' && typeof response.data.data.total === 'number') {
                            this.registeredCount = response.data.data.total;
                            
                            // Only fetch all registered teachers if payment_status filter might be used
                            // This avoids unnecessary API calls and rate limiting
                            const totalPages = response.data.data.last_page || 1;
                            if (totalPages > 1) {
                                // Only fetch all pages if we need accurate payment counts
                                // We'll fetch lazily when payment_status filter is applied
                                // For now, just store first page data as fallback
                                if (response.data.data.data && Array.isArray(response.data.data.data)) {
                                    this.allRegisteredTeachers = response.data.data.data.filter(teacher => {
                                        return teacher.registered === 'Registered';
                                    });
                                }
                            } else {
                                // Single page, store the data directly
                                if (response.data.data.data && Array.isArray(response.data.data.data)) {
                                    this.allRegisteredTeachers = response.data.data.data.filter(teacher => {
                                        return teacher.registered === 'Registered';
                                    });
                                    
                                    console.log('Single page - All registered teachers loaded:', this.allRegisteredTeachers.length);
                                    console.log('Registered count from API:', this.registeredCount);
                                    console.log('Paid count:', this.paidTeachersCount);
                                    console.log('Not Paid count:', this.notPaidTeachersCount);
                                    console.log('Sum (Paid + Not Paid):', this.paidTeachersCount + this.notPaidTeachersCount);
                                }
                            }
                        } else if (Array.isArray(response.data.data)) {
                            this.allRegisteredTeachers = response.data.data.filter(teacher => {
                                return teacher.registered === 'Registered';
                            });
                            this.registeredCount = this.allRegisteredTeachers.length;
                            
                            console.log('Array response - All registered teachers loaded:', this.allRegisteredTeachers.length);
                            console.log('Paid count:', this.paidTeachersCount);
                            console.log('Not Paid count:', this.notPaidTeachersCount);
                            console.log('Sum (Paid + Not Paid):', this.paidTeachersCount + this.notPaidTeachersCount);
                        }
                    }
                })
                .catch(() => {
                    this.registeredCount = 0;
                    this.allRegisteredTeachers = [];
                });
        },

        // Fetch all registered teachers across all pages for accurate payment status counting
        // Uses sequential requests with delays to avoid rate limiting
        async fetchAllRegisteredTeachers(totalPages) {
            let queryParams = new URLSearchParams();
            queryParams.append('event_id', '100');
            queryParams.append('per_page', '500'); // Request large per_page to reduce number of requests

            // Apply scope: either explicit filters or user-level scoping
            if (this.filter_district) {
                queryParams.append('district_id', this.filter_district);
            } else if (this.currentUser && this.currentUser.user_level >= 2 && this.currentUser.district_id) {
                queryParams.append('district_id', this.currentUser.district_id);
            }

            if (this.filter_zone) {
                queryParams.append('zone_id', this.filter_zone);
            } else if (this.currentUser && this.currentUser.user_level >= 3 && this.currentUser.zone_id) {
                queryParams.append('zone_id', this.currentUser.zone_id);
            }

            if (this.filter_unit) {
                queryParams.append('unit_id', this.filter_unit);
            } else if (this.currentUser && this.currentUser.user_level >= 4 && this.currentUser.unit_id) {
                queryParams.append('unit_id', this.currentUser.unit_id);
            }

            if (this.filter_sex) {
                queryParams.append('gender', this.filter_sex);
            }

            // Request only registered subset
            queryParams.append('registered', 'Y');

            // Use appropriate endpoint based on whether viewing professionals or teachers
            const endpoint = this.isProfessionals ? 'professionals-unregistered' : 'teachers-unregistered';

            let allTeachers = [];
            let successfulRequests = 0;
            const delayBetweenRequests = 500; // 500ms delay between requests to avoid rate limiting

            try {
                // Fetch pages sequentially with delays to avoid rate limiting
                for (let page = 1; page <= totalPages; page++) {
                    try {
                        const pageQueryParams = new URLSearchParams(queryParams);
                        pageQueryParams.append('page', page);
                        const url = `${endpoint}?${pageQueryParams.toString()}`;
                        
                        const response = await UserService.authGetRequest(url);
                        
                        if (response && response.data && response.data.status === 'success') {
                            if (response.data.data && typeof response.data.data === 'object' && response.data.data.data) {
                                allTeachers = allTeachers.concat(response.data.data.data || []);
                            } else if (Array.isArray(response.data.data)) {
                                allTeachers = allTeachers.concat(response.data.data);
                            }
                            successfulRequests++;
                        }
                        
                        // Add delay between requests (except after the last one)
                        if (page < totalPages) {
                            await new Promise(resolve => setTimeout(resolve, delayBetweenRequests));
                        }
                    } catch (error) {
                        console.warn(`Error fetching page ${page} of registered teachers:`, error);
                        // Continue with other pages even if one fails
                    }
                }
                
                // Filter to only registered teachers and store
                this.allRegisteredTeachers = allTeachers.filter(teacher => {
                    return teacher.registered === 'Registered';
                });
                
                    console.log(`All registered teachers loaded: ${this.allRegisteredTeachers.length} (${successfulRequests}/${totalPages} pages successful)`);
                    console.log('Registered count from API:', this.registeredCount);
                    console.log('Paid count:', this.paidTeachersCount);
                    console.log('Not Paid count:', this.notPaidTeachersCount);
                    console.log('Sum (Paid + Not Paid):', this.paidTeachersCount + this.notPaidTeachersCount);
                    
                    // Force reactivity update if payment_status filter is active
                    if (this.payment_status) {
                        this.$forceUpdate();
                    }
                
                // Validate counts match
                if (this.registeredCount !== (this.paidTeachersCount + this.notPaidTeachersCount)) {
                    console.warn(`Count mismatch: Registered (${this.registeredCount}) !== Paid (${this.paidTeachersCount}) + Not Paid (${this.notPaidTeachersCount})`);
                    // Check for teachers with unexpected payment_status values
                    const statusCounts = {};
                    this.allRegisteredTeachers.forEach(teacher => {
                        const status = (teacher.payment_status || 'null/empty').trim();
                        statusCounts[status] = (statusCounts[status] || 0) + 1;
                    });
                    console.log('Payment status breakdown:', statusCounts);
                }
            } catch (error) {
                console.error('Error fetching all registered teachers:', error);
                // Don't clear allRegisteredTeachers on error, keep what we have
                // The counts will fall back to using API total
            }
        },

        // Get professionals unregistered for an event
        getProfessionalsUnregistered(page = 1) {
            this.professionalsUnregisteredLoading = true;

            let queryParams = new URLSearchParams();
            queryParams.append('event_id', '100');
            queryParams.append('page', page);

            if (this.currentUser && this.currentUser.user_level >= 2 && this.currentUser.district_id) {
                queryParams.append('district_id', this.currentUser.district_id);
            }
            if (this.currentUser && this.currentUser.user_level >= 3 && this.currentUser.zone_id) {
                queryParams.append('zone_id', this.currentUser.zone_id);
            }
            if (this.currentUser && this.currentUser.user_level >= 4 && this.currentUser.unit_id) {
                queryParams.append('unit_id', this.currentUser.unit_id);
            }

            const url = `professionals-unregistered?${queryParams.toString()}`;
            console.log('Loading professionals with URL:', url);

            return UserService.authGetRequest(url)
                .then((response) => {
                    console.log('Professionals API Response:', response);

                    if (response && response.data && response.data.status === 'success') {

                        if (response.data.data && typeof response.data.data === 'object' && response.data.data.data) {

                            this.professionalsUnregistered = {
                                data: response.data.data.data || [],
                                total: response.data.data.total || 0,
                                per_page: response.data.data.per_page || 20,
                                current_page: response.data.data.current_page || 1,
                                last_page: response.data.data.last_page || 1,
                                from: response.data.data.from || 0,
                                to: response.data.data.to || 0
                            };
                        } else {
                            const allData = response.data.data || [];
                            const perPage = 20;
                            const totalItems = allData.length;
                            const totalPages = Math.ceil(totalItems / perPage);
                            const startIndex = (page - 1) * perPage;
                            const endIndex = startIndex + perPage;
                            const pageData = allData.slice(startIndex, endIndex);

                            this.professionalsUnregistered = {
                                data: pageData,
                                total: totalItems,
                                per_page: perPage,
                                current_page: page,
                                last_page: totalPages,
                                from: startIndex + 1,
                                to: Math.min(endIndex, totalItems)
                            };
                        }
                    } else {
                        this.professionalsUnregistered = {
                            data: [],
                            total: 0,
                            per_page: 20,
                            current_page: 1,
                            last_page: 1,
                            from: 0,
                            to: 0
                        };
                    }

                    console.log('Professionals loaded:', this.professionalsUnregistered.data.length);
                    this.professionalsUnregisteredLoading = false;
                })
                .catch((error) => {
                    console.error('Error fetching professionals:', error);
                    this.professionalsUnregistered = {
                        data: [],
                        total: 0,
                        per_page: 20,
                        current_page: 1,
                        last_page: 1,
                        from: 0,
                        to: 0
                    };
                    this.professionalsUnregisteredLoading = false;
                });
        },

        // Get professionals with filters applied
        getProfessionalsUnregisteredWithFilter(page = 1) {
            this.professionalsUnregisteredLoading = true;
            this.loading_list = true;

            let queryParams = new URLSearchParams();
            queryParams.append('event_id', '100');
            queryParams.append('page', page);

            if (this.filter_district) {
                queryParams.append('district_id', this.filter_district);
            }

            if (this.filter_zone) {
                queryParams.append('zone_id', this.filter_zone);
            }

            if (this.filter_unit) {
                queryParams.append('unit_id', this.filter_unit);
            }

            if (this.filter_sex) {
                queryParams.append('gender', this.filter_sex);
            }

            if (this.filter_registered) {
                const flag = this.filter_registered === 'registered' ? 'Y' : this.filter_registered === 'not_register' ? 'N' : '';
                if (flag) {
                    queryParams.append('registered', flag);
                }
            }

            if (this.payment_status) {
                queryParams.append('payment_status', this.payment_status);
            }

            const url = `professionals-unregistered?${queryParams.toString()}`;
            console.log('Filtering professionals with URL:', url);

            return UserService.authGetRequest(url)
                .then((response) => {
                    console.log('Filtered Professionals Response:', response);

                    if (response && response.data && response.data.status === 'success') {

                        if (response.data.data && typeof response.data.data === 'object' && response.data.data.data) {
                            let filteredData = response.data.data.data || [];

                            this.professionalsUnregistered = {
                                data: filteredData,
                                total: response.data.data.total || 0,
                                per_page: response.data.data.per_page || 20,
                                current_page: response.data.data.current_page || 1,
                                last_page: response.data.data.last_page || 1,
                                from: response.data.data.from || 0,
                                to: response.data.data.to || 0
                            };
                        } else {
                            let allData = response.data.data || [];
                            
                            const perPage = 20;
                            const totalItems = allData.length;
                            const totalPages = Math.ceil(totalItems / perPage);
                            const startIndex = (page - 1) * perPage;
                            const endIndex = startIndex + perPage;
                            const pageData = allData.slice(startIndex, endIndex);

                            this.professionalsUnregistered = {
                                data: pageData,
                                total: totalItems,
                                per_page: perPage,
                                current_page: page,
                                last_page: totalPages,
                                from: startIndex + 1,
                                to: Math.min(endIndex, totalItems)
                            };
                        }
                    } else {
                        this.professionalsUnregistered = {
                            data: [],
                            total: 0,
                            per_page: 20,
                            current_page: 1,
                            last_page: 1,
                            from: 0,
                            to: 0
                        };
                    }

                    console.log('Filtered professionals count:', this.professionalsUnregistered.data.length);
                    this.professionalsUnregisteredLoading = false;
                    this.loading_list = false;
                })
                .catch((error) => {
                    console.error('Error fetching filtered professionals:', error);
                    if (!this.professionalsUnregistered || !this.professionalsUnregistered.data || this.professionalsUnregistered.data.length === 0) {
                        this.professionalsUnregistered = {
                            data: [],
                            total: 0,
                            per_page: 20,
                            current_page: 1,
                            last_page: 1,
                            from: 0,
                            to: 0
                        };
                    }
                    this.professionalsUnregisteredLoading = false;
                    this.loading_list = false;
                });
        },

        getTeachersUnregisteredWithFilter(page = 1) {
            this.teachersUnregisteredLoading = true;
            this.loading_list = true;

            let queryParams = new URLSearchParams();
            queryParams.append('event_id', '100');
            queryParams.append('page', page);

            if (this.filter_district) {
                queryParams.append('district_id', this.filter_district);
            }

            if (this.filter_zone) {
                queryParams.append('zone_id', this.filter_zone);
            }

            if (this.filter_unit) {
                queryParams.append('unit_id', this.filter_unit);
            }

            if (this.filter_sex) {
                queryParams.append('gender', this.filter_sex);
            }

            if (this.filter_registered) {
                // API expects Y/N for registered filter
                const flag = this.filter_registered === 'registered' ? 'Y' : this.filter_registered === 'not_register' ? 'N' : '';
                if (flag) {
                    queryParams.append('registered', flag);
                }
            }

                if (this.payment_status) {
                    queryParams.append('payment_status', this.payment_status);
                }

            const url = `teachers-unregistered?${queryParams.toString()}`;
            console.log('Filtering teachers with URL:', url);

            return UserService.authGetRequest(url)
                .then((response) => {
                    console.log('Filtered Teachers Response:', response);

                    if (response && response.data && response.data.status === 'success') {

                        if (response.data.data && typeof response.data.data === 'object' && response.data.data.data) {
                            // Apply client-side payment_status filter as fallback to ensure correct filtering
                            let filteredData = response.data.data.data || [];
                            const apiTotal = response.data.data.total || 0;
                            console.log(`API Response - Total from backend: ${apiTotal}, Current page items: ${filteredData.length}, Payment status filter: ${this.payment_status}`);
                            
                            if (this.payment_status) {
                                const originalLength = filteredData.length;
                                filteredData = filteredData.filter(teacher => {
                                    const teacherPaymentStatus = (teacher.payment_status || '').trim();
                                    return teacherPaymentStatus === this.payment_status.trim();
                                });
                                
                                // If we filtered out any items, we need to adjust totals
                                // Note: This is a workaround - ideally backend should filter correctly
                                console.log(`Payment filter: ${originalLength} items before, ${filteredData.length} items after filtering for "${this.payment_status}"`);
                                console.log(`API total was: ${apiTotal}, but filtered page shows ${filteredData.length} items`);
                            }

                            // When payment_status filter is applied, update total appropriately
                            // Use API total as base, but if we have all registered teachers, use accurate computed count
                            let updatedTotal = response.data.data.total || 0;
                            
                            if (this.payment_status) {
                                // If we have all registered teachers loaded, use the accurate computed count
                                if (this.allRegisteredTeachers.length >= this.registeredCount && this.registeredCount > 0) {
                                    if (this.payment_status === 'Paid') {
                                        updatedTotal = this.paidTeachersCount;
                                    } else if (this.payment_status === 'Not Paid') {
                                        updatedTotal = this.notPaidTeachersCount;
                                    }
                                } else {
                                    // Use API total (even if slightly inaccurate) rather than current page count
                                    // The API should filter correctly when payment_status is in query params
                                    // If client-side filtering removed items, that's just for display on this page
                                    // The total should still reflect all matching records across all pages
                                    updatedTotal = response.data.data.total || 0;
                                    console.log(`Using API total for payment filter: ${updatedTotal} (allRegisteredTeachers: ${this.allRegisteredTeachers.length}, registeredCount: ${this.registeredCount})`);
                                }
                            }
                            
                            this.teachersUnregistered = {
                                data: filteredData,
                                total: updatedTotal,
                                per_page: response.data.data.per_page || 20,
                                current_page: response.data.data.current_page || 1,
                                last_page: response.data.data.last_page || 1,
                                from: response.data.data.from || 0,
                                to: response.data.data.to || 0
                            };
                        } else {
                            let allData = response.data.data || [];
                            
                            // Apply client-side payment_status filter as fallback to ensure correct filtering
                            if (this.payment_status) {
                                allData = allData.filter(teacher => {
                                    const teacherPaymentStatus = (teacher.payment_status || '').trim();
                                    return teacherPaymentStatus === this.payment_status.trim();
                                });
                            }
                            
                            const perPage = 20;
                            const totalItems = allData.length;
                            const totalPages = Math.ceil(totalItems / perPage);
                            const startIndex = (page - 1) * perPage;
                            const endIndex = startIndex + perPage;
                            const pageData = allData.slice(startIndex, endIndex);

                            this.teachersUnregistered = {
                                data: pageData,
                                total: totalItems,
                                per_page: perPage,
                                current_page: page,
                                last_page: totalPages,
                                from: startIndex + 1,
                                to: Math.min(endIndex, totalItems)
                            };

                            this.allTeachersUnfiltered = allData;
                        }
                    } else {
                        this.teachersUnregistered = {
                            data: [],
                            total: 0,
                            per_page: 20,
                            current_page: 1,
                            last_page: 1,
                            from: 0,
                            to: 0
                        };
                    }

                    console.log('Filtered teachers count:', this.teachersUnregistered.data.length);
                    console.log('Payment status filter applied:', this.payment_status);
                    this.teachersUnregisteredLoading = false;
                    this.loading_list = false;
                })
                .catch((error) => {
                    console.error('Error fetching filtered teachers:', error);
                    // Preserve previous data if available, otherwise set empty
                    if (!this.teachersUnregistered || !this.teachersUnregistered.data || this.teachersUnregistered.data.length === 0) {
                        this.teachersUnregistered = {
                            data: [],
                            total: this.registeredCount || 0, // Use registeredCount as fallback
                            per_page: 20,
                            current_page: 1,
                            last_page: 1,
                            from: 0,
                            to: 0
                        };
                    }
                    this.teachersUnregisteredLoading = false;
                    this.loading_list = false;
                });
        },

        refreshTeachers() {
            const hasFilters = this.filter_district || this.filter_zone || this.filter_unit ||
                this.filter_sex || this.filter_member || this.filter_registered || this.payment_status;

            console.log('Refreshing teachers, has filters:', hasFilters);

            if (this.isProfessionals) {
                if (hasFilters) {
                    this.getProfessionalsUnregisteredWithFilter(1);
                } else {
                    this.getProfessionalsUnregistered(1);
                }
            } else {
                if (hasFilters) {
                    this.getTeachersUnregisteredWithFilter(1);
                } else {
                    this.getTeachersUnregistered(1);
                }
            }
        },

        onPaginationClick(page) {
            console.log('Pagination clicked, page:', page);

            if (this.allTeachersUnfiltered && this.allTeachersUnfiltered.length > 0) {
                this.paginateStoredData(page);
            } else {
                const hasFilters = this.filter_district || this.filter_zone || this.filter_unit ||
                    this.filter_sex || this.filter_member || this.filter_registered || this.payment_status;

                if (this.isProfessionals) {
                    if (hasFilters) {
                        this.getProfessionalsUnregisteredWithFilter(page);
                    } else {
                        this.getProfessionalsUnregistered(page);
                    }
                } else {
                    if (hasFilters) {
                        this.getTeachersUnregisteredWithFilter(page);
                    } else {
                        this.getTeachersUnregistered(page);
                    }
                }
            }

            // Collapse the filter accordion when navigating pages
            this.$nextTick(() => {
                const accordionElement = $('#accordion001');
                const accordionButton = $('.accordion-button[data-bs-target="#accordion001"]');
                if (accordionElement.length) {
                    accordionElement.removeClass('show');
                    accordionElement.collapse('hide');
                }
                if (accordionButton.length) {
                    accordionButton.addClass('collapsed');
                    accordionButton.attr('aria-expanded', 'false');
                }
            });
        },

        paginateStoredData(page) {
            const allData = this.allTeachersUnfiltered;
            const perPage = 20;
            const totalItems = allData.length;
            const totalPages = Math.ceil(totalItems / perPage);
            const startIndex = (page - 1) * perPage;
            const endIndex = startIndex + perPage;
            const pageData = allData.slice(startIndex, endIndex);

            this.teachersUnregistered = {
                data: pageData,
                total: totalItems,
                per_page: perPage,
                current_page: page,
                last_page: totalPages,
                from: startIndex + 1,
                to: Math.min(endIndex, totalItems)
            };
        },

        displayAll() {
            this.search_qry = '';
            this.searchResponse.contact = '';
            this.searchResponse.message = '';
        },

        convertToJson(subject) {
            if (!subject) return [];
            try {
                return JSON.parse(subject.replace(/&quot;/ig, '"'));
            } catch (e) {
                return [];
            }
        },

        search(mobile = null) {
            if (mobile) {
                this.search_qry = mobile;
            }
            this.search_loading = true;
            let data = {
                q: this.search_qry,
                event_type: this.$route.params.event_id || this.$route.params.slug,
                level: 'admin'
            }

            UserService.authPostRequest('v2/get-call-campign-contact', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.searchResponse = response.data.data;
                        this.formData.id = this.searchResponse.contact.contact_id;
                        this.formData.wisdom_member = this.searchResponse.contact.wisdom_member;
                        this.formData.name = this.searchResponse.contact.name;
                        this.formData.mobile = this.searchResponse.contact.mobile;
                        this.formData.mobile2 = this.searchResponse.contact.mobile2;
                        this.formData.sex = this.searchResponse.contact.gender;
                        this.formData.district = this.searchResponse.contact.district_id;
                        this.formData.place = this.searchResponse.contact.place;
                        this.formData.comments = this.searchResponse.contact.comments;
                        this.formData.status = this.searchResponse.contact.calling_status;
                        this.formData.visited_status = this.searchResponse.contact.visited_status;

                        if (this.searchResponse.questian_responses) {
                            let count = 0;
                            this.searchResponse.questian_responses.forEach(element => {
                                this.questians_responses[count] = element.answer_text;
                                count++;
                            });
                        }
                        this.$root.updateParent('Call Campaign');
                    }
                    this.search_loading = false;
                },
                (error) => {
                    this.search_loading = false;
                    this.alert_type = 'Error';
                    this.alert_message = error.data ? error.data.message : 'Search failed';
                    this.$refs.alert_model.openModel();
                }
            );
        },

        getComboboxValues(code, id = null) {
            var data = {
                code: code,
                type_id: id,
            };

            return UserService.getCombobox(data).then(
                (response) => {
                    switch (code) {
                        case "CALL_CAMPAIGN_STATUS":
                            this.status_list = response.data.data.list.options;
                            break;
                        default:
                            break;
                    }
                },
                (error) => {
                    console.error('Combobox error:', error);
                }
            );
        },

        handleRegistration(data) {
            this.btn_loading = true;
            data.contact_id = data.id;
            data.id = this.searchResponse.contact.id;
            data.visited_status = this.formData.visited_status;

            UserService.authPostRequest("v2/store-campign-status", data).then(
                (response) => {
                    if (response.data.status == "success") {
                        this.alert_type = "Success";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.searchResponse.contact = '';
                        this.search_qry = '';
                        this.getCampign();
                    } else if (response.data.status == "warning") {
                        this.alert_type = "Warning";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                    } else {
                        this.alert_type = "Error";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                    }
                    this.btn_loading = false;
                },
                (error) => {
                    this.btn_loading = false;
                    console.error('Registration error:', error);
                }
            );
        },

        getCampign(page = 1) {
            this.loading_list = true;
            let data = {
                id: this.$route.params.slug,
                mobile: this.$route.params.mobile ? this.$route.params.mobile : null,
                filter_district: this.filter_district ? this.filter_district : null,
                filter_zone: this.filter_zone ? this.filter_zone : null,
                filter_unit: this.filter_unit ? this.filter_unit : null,
                filter_sex: this.filter_sex ? this.filter_sex : null,
                filter_registered: this.filter_registered ? this.filter_registered : null,
                filter_member: this.filter_member ? this.filter_member : null
            }
            UserService.authPostRequest(`v2/get-event-call-campign?page=${page}`, data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.loading_list = false;
                        this.responseData = response.data.data;
                        this.pending_contacts = response.data.data.pending_contacts;
                        this.all_contacts = response.data.data.all_contacts;
                        this.district_list = response.data.data.district;
                        this.getZoneList(this.responseData.permissions.district_id);
                        if (this.responseData.questians) {
                            let count = 0;
                            this.responseData.questians.forEach(element => {
                                this.questians_responses[count] = element.answer_text;
                                count++;
                            });
                        }
                        this.$root.updateParent(this.responseData.page_title);
                    } else {
                        this.loading_list = true;
                    }
                },
                (error) => {
                    this.loading_list = false;
                    this.alert_type = 'Error';
                    this.alert_message = error.data.message;
                    this.$refs.alert_model.openModel();
                }
            );
        },

        mobileToWhatsapp(mobileNumber) {
            if (!mobileNumber) return '';
            const cleanNumber = mobileNumber.toString().replace(/\D/g, '');
            if (cleanNumber.length === 10) {
                return '91' + cleanNumber;
            }
            return cleanNumber;
        },

        gotoReport(mobile) {
            if (this.responseData.campign && this.responseData.campign.reporting_campaign_id) {
                this.$router.push('/call-follow-up/' + this.responseData.campign.reporting_campaign_id + '/' + mobile);
            }
        },

        getDistrictList() {
            let data = {}
            return UserService.authPostRequest(`get-district-by-id`, data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.district_list = response.data.data.list;
                    }
                },
                (error) => {
                    console.error('District list error:', error);
                }
            );
        },

        getZoneList(district_id) {
            if (!district_id) return;

            let data = { district_id: district_id }
            UserService.authPostRequest(`get-zone-by-id`, data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.zone_list = response.data.data.list;
                    }
                },
                (error) => {
                    console.error('Zone list error:', error);
                }
            );
        },

        getUnitList(zone_id) {
            if (!zone_id) return;

            let data = { zone_id: zone_id }
            UserService.authPostRequest(`get-unit-by-id`, data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.unit_list = response.data.data.list;
                    }
                },
                (error) => {
                    console.error('Unit list error:', error);
                }
            );
        },

        clearFilter() {
            console.log('Clearing all filters...');

            this.filter_district = '';
            this.filter_zone = '';
            this.filter_member = '';
            this.filter_unit = '';
            this.filter_registered = '';
            this.filter_sex = '';
            this.payment_status = '';

            this.zone_list = [];
            this.unit_list = [];

            if (this.currentUser && this.currentUser.district_id) {
                this.getZoneList(this.currentUser.district_id);
            }
            
            // Call appropriate API based on route
            if (this.isProfessionals) {
                this.getProfessionalsUnregistered();
            } else {
                this.getTeachersUnregistered();
            }
        },

        applyFilters() {
            console.log('Applying filters...');
            console.log('Filters:', {
                district: this.filter_district,
                zone: this.filter_zone,
                unit: this.filter_unit,
                sex: this.filter_sex,
                member: this.filter_member,
                registered: this.filter_registered,
                payment_status: this.payment_status
            });


            const hasFilters = this.filter_district || this.filter_zone || this.filter_unit ||
                this.filter_sex || this.filter_member || this.filter_registered || this.payment_status;

            if (this.isProfessionals) {
                if (hasFilters) {
                    this.getProfessionalsUnregisteredWithFilter();
                } else {
                    this.getProfessionalsUnregistered();
                }
            } else {
                if (hasFilters) {
                    this.getTeachersUnregisteredWithFilter();
                } else {
                    this.getTeachersUnregistered();
                }
            }
            // Refresh registered total alongside list
            this.fetchRegisteredCount();
            
            // If payment_status filter is applied and we need all registered teachers for accurate counts
            // Trigger fetch only if we don't have all data yet and registeredCount > 0
            if (this.payment_status && this.allRegisteredTeachers.length < this.registeredCount && this.registeredCount > 0) {
                const totalPages = Math.ceil(this.registeredCount / 500) || 1;
                if (totalPages > 1) {
                    // Trigger fetch with delay to avoid immediate rate limiting
                    setTimeout(() => {
                        this.fetchAllRegisteredTeachers(totalPages);
                    }, 1000);
                }
            }

            // Collapse the filter accordion after applying filters
            this.$nextTick(() => {
                const accordionElement = $('#accordion001');
                const accordionButton = $('.accordion-button[data-bs-target="#accordion001"]');
                if (accordionElement.length) {
                    accordionElement.removeClass('show');
                    accordionElement.collapse('hide');
                }
                if (accordionButton.length) {
                    accordionButton.addClass('collapsed');
                    accordionButton.attr('aria-expanded', 'false');
                }
            });
        },

        applyClientSideFilters(teachers) {
            let filtered = [...teachers];


            if (this.filter_district) {
                filtered = filtered.filter(t => t.district_id == this.filter_district);
            }


            if (this.filter_zone) {
                filtered = filtered.filter(t => t.zone_id == this.filter_zone);
            }


            if (this.filter_unit) {
                filtered = filtered.filter(t => t.unit_id == this.filter_unit);
            }


            if (this.filter_sex) {
                filtered = filtered.filter(t => {
                    const gender = (t.gender || t.sex || '').toLowerCase();
                    return gender === this.filter_sex.toLowerCase();
                });
            }


            if (this.filter_member) {
                if (this.filter_member === 'member') {
                    filtered = filtered.filter(t => t.is_member === true || t.is_member === 1 || t.is_member === 'Y');
                } else if (this.filter_member === 'not_member') {
                    filtered = filtered.filter(t => t.is_member === false || t.is_member === 0 || t.is_member === 'N' || !t.is_member);
                }
            }


            if (this.filter_registered) {
                if (this.filter_registered === 'registered') {
                    filtered = filtered.filter(t => t.registered === 'Registered');
                } else if (this.filter_registered === 'not_register') {
                    filtered = filtered.filter(t => t.registered !== 'Registered');
                }
            }

            return filtered;
        },
    },
    watch: {
        loading_list(newVal, oldVal) {
            console.log(`loading_list changed from ${oldVal} to ${newVal}`);
        },
        'responseData.all_contacts': {
            handler(newVal) {
                console.log('all_contacts updated:', newVal);
            },
            deep: true
        },

        filter_district(newVal, oldVal) {
            if (oldVal !== undefined && newVal !== oldVal) {
                this.filter_zone = '';
                this.filter_unit = '';
                this.zone_list = [];
                this.unit_list = [];

                if (newVal) {
                    this.getZoneList(newVal);
                }
            }
        },
        filter_zone(newVal, oldVal) {
            if (oldVal !== undefined && newVal !== oldVal) {
                this.filter_unit = '';
                this.unit_list = [];

                if (newVal) {
                    this.getUnitList(newVal);
                }
            }
        }
    }
};
</script>

<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

.listview>li footer {
    color: #171617;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.image-listview.text>li:after {
    left: 0px;
    background-color: #1a418c;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.avatar-section .button-payment {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 5px;
    bottom: 0;
}

.avatar-section .payment-verified {
    background: #05d0a4;
}

/* Teachers List Styling */
.teachers-list-wrapper {
    background: #f8f9fa;
    padding: 0.5rem;
    border-radius: 0.25rem;
    border: 1px solid #dee2e6;
}

.teachers-list {
    max-height: 250px;
    overflow-y: auto;
}

.teachers-list::-webkit-scrollbar {
    width: 6px;
}

.teachers-list::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.teachers-list::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
}

.list-group-item {
    padding: 0.5rem 0.75rem;
}

.list-group-item:hover {
    background-color: #f8f9fa;
}

.list-group-item .btn-sm {
    padding: 0.125rem 0.375rem;
}

.list-group-item ion-icon {
    font-size: 0.875rem;
}

/* Pagination Styles */
.pagination-container {
    display: flex;
    column-gap: 10px;
}

.paginate-buttons {
    height: 40px;
    width: 40px;
    border-radius: 20px;
    cursor: pointer;
    background-color: rgb(242, 242, 242);
    border: 1px solid rgb(217, 217, 217);
    color: black;
}

.paginate-buttons:hover {
    background-color: #d8d8d8;
}

.active-page {
    background-color: #3498db !important;
    border: 1px solid #3498db !important;
    color: white !important;
}

.active-page:hover {
    background-color: #2988c8;
}
</style>